import React from "react";
import { APP_NAME } from "../../utils/config";

const Image = ({ src, ...props }) => {
  return (
    <>
      <img
        src={src}
        loading="lazy"
        alt={APP_NAME}
        onClick={props.onClick}
        {...props}
      />
    </>
  );
};

export default Image;
